export const BreadTagsHistory = (props) => {
    const datas = props.datas;
    const collection = [1955, 1990, 2000, 2010, 2020];
    const history = [];
    let start = 0;
    for (const limit of [1990, 2000, 2010, 2020]) {
        const end = datas.findIndex(year => Number(year) === limit);
        history.push(datas.slice(start, end + 1));
        start = end + 1;
    }
    history.push(datas.slice(start));
    return (
        <div className="breadtags">
            {collection.map((year, i) => {
                let target, all;
                return (
                    <div className="breadtags-button" key={i}>
                        <div id={i} className="tag" onClick={(year) => {
                            target = document.getElementById(`slide-${year.target.id}`);
                            all = document.getElementsByClassName('breadtags-slide');
                            for (let j = 0; j < all.length; j++) {
                                all[j].classList.remove('show');
                                all[j].classList.add('hide');
                            }
                            target.classList.remove('hide');
                            target.classList.add('show');
                        }}>{year}</div>
                    </div>
                )
            })}
            {history.map((items, i) => {
                return (
                    <div className="breadtags-slide hide" id={`slide-${i}`} key={i}>
                        <div className="breadtags-title">{`Années ${collection[i]}`}</div>
                        <div className="breadtags-wrap">
                            {items.map((year, i) => {
                                return (
                                    <a className="tag-child" href={`#${year}`} alt={year} key={i}>{year}</a>
                                )
                            })}
                        </div>
                    </div>
                )
            })}
        </div>
    )

}
